export default __webpack_public_path__ + "static/loaded_truck-6c01dcd1b0df6604ff1e9e17caac0ff7.jpg";